require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./increasing-performance-through-improved-shift-policies-and-practices.json") })
        }
      }, "path---increasing-performance-through-improved-shift-policies-and-practices");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---increasing-performance-through-improved-shift-policies-and-practices!./.cache/json/increasing-performance-through-improved-shift-policies-and-practices.json
// module id = 908
// module chunks = 231608221292675